import { Component, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ButtonModule } from '../button/button.module'

@Component({
  selector: 'app-error',
  template: `
    <div class="container">
      <span i18n="@@error.title">
        Something went wrong. Please try again.
      </span>
      <app-button btn-medium btn-primary (click)="window.location.reload()" i18n="@@error.refresh-page-button.label">
        Refresh page
      </app-button>
    </div>
  `,
  styles: [`
    @use "sass:map";
    @import 'src/assets/_colors';
    .container {
      display: flex;
      height: 60vh;
      max-height: 382px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    span {
      margin-bottom: 24px;
    }
  `],
  imports: [
    CommonModule,
    ButtonModule
  ]
})
export class ErrorComponent {
  window = inject(Window)
}
